import React, { useState } from 'react';
import { addTicketProgressStatus } from '../../api/settingApi';
import { useNotification } from "../../context/NotificationContext";

const NewProgressStatus = () => {
    const notify = useNotification();
    const [formData, setFormData] = useState({
        name: '',
    });
    const [errors, setErrors] = useState({});

    const validate = () => {
        const newErrors = {};
        if (!formData.name) {
            newErrors.name = 'Progress Status Name is required';
        }
        return newErrors;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        const validationErrors = validate();
        if (Object.keys(validationErrors).length > 0) {
            setErrors(validationErrors);
            return;
        }
        setErrors({});
        try {
            const response = await addTicketProgressStatus(formData);
            setFormData({ name: '' });
            console.log(response);
            notify("success", "Ticket Progress Status Added");
        } catch (error) {
            console.error('Error submitting form:', error);
            notify("error", error?.response?.data?.message || error.message || "An error occurred");
        }
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({ ...prev, [name]: value }));
    }

    return (
        <div className="flex justify-center items-center h-screen">
            <form onSubmit={handleSubmit} className="bg-white shadow-lg rounded-xl px-8 pt-6 pb-8 w-full max-w-md border-2 border-teal-300">
                <h2 className="text-3xl font-extrabold text-blue-700 text-center mb-6">Ticket Progress Status</h2>
                <div>
                    <label className="block text-sm font-medium text-gray-800">Name</label>
                    <input 
                        type="text" 
                        name="name" 
                        value={formData.name} 
                        onChange={handleChange}
                        className="block w-full px-4 py-3 mt-2 border rounded-lg focus:ring-2 focus:ring-teal-500"
                    />
                    {errors.name && (
                        <p className="text-red-600 text-sm mt-1">{errors.name}</p>
                    )}
                </div>
                <div className="mt-6">
                    <button 
                        type="submit" 
                        className="bg-orange-500 hover:bg-orange-600 text-white font-bold py-3 px-6 rounded-lg w-full focus:outline-none focus:ring-2 focus:ring-orange-500"
                    >
                        Submit
                    </button>
                </div>
            </form>
        </div>
    );
}

export default NewProgressStatus;
